@if (masterViewModel.search.isVisible$ | async) {
  <div class="aside-left-control-top-content">
    <div class="search-container">
      <nts-text-button [icon]="'search'"
      (onClicked)="masterViewModel.search.execSearch(masterViewModel.search.value)"></nts-text-button>
      <nts-search-text-box [propertyViewModel]="masterViewModel.search" placeholder="Search">
      </nts-search-text-box>
    </div>
  </div>
}
<div
  [ngClass]="{'aside-left-control-bottom-content': masterViewModel.search.isVisibleExtendedFilterTitle$ | async, 'aside-left-control-bottom-content-without-title': !(masterViewModel.search.isVisibleExtendedFilterTitle$ | async)}">
  <div class="filter-pane-content">

    @if (masterViewModel.showExtendedFilter) {
      <div>
        <div class="caption-panel">
          @if (masterViewModel.search.isVisibleExtendedFilterTitle$ | async) {
            <nts-label-box
            [label]="masterViewModel.search.extendedFilterTitle"></nts-label-box>
          }
        </div>
        <div class="">
          <div class="filter-lines-container">
            @for (filter of masterViewModel.extendedFiltersList; track filter) {
              <div class="advanced-list-filter-line">
                <div class="header">
                  <div class="caption-container">
                    <nts-label-box [title]="filter.property.metadataDescription" [label]="filter.property.metadataShortDescription"></nts-label-box>
                  </div>
                </div>
                @if (isString(filter.property)) {
                  <nts-string-text-box [multiline]="false"
                    (keyDown)="onDown($event, filter.property)" [propertyViewModel]="filter.property" [updateOnBlur]="false">
                  </nts-string-text-box>
                }
                @if (isNumeric(filter.property)) {
                  <nts-numeric-text-box (keyDown)="onDown($event, filter.property)"
                    [propertyViewModel]="filter.property" [updateOnBlur]="false">
                  </nts-numeric-text-box>
                }
                @if (isEnum(filter.property)) {
                  <nts-enum-text-box [appendTo]="'body'"
                    (keyDown)="onDown($event, filter.property)" [propertyViewModel]="filter.property">
                  </nts-enum-text-box>
                }
                @if (isBool(filter.property)) {
                  <nts-toggle-text-box (keyDown)="onDown($event, filter.property)"
                    [propertyViewModel]="filter.property">
                  </nts-toggle-text-box>
                }
                @if (isDate(filter.property)) {
                  <nts-date-text-box (keyDown)="onDown($event, filter.property)"
                    [propertyViewModel]="filter.property">
                  </nts-date-text-box>
                }
                @if (isDateTimeOffset(filter.property)) {
                  <nts-date-offset-text-box (keyDown)="onDown($event, filter.property)"
                    [propertyViewModel]="filter.property">
                  </nts-date-offset-text-box>
                }
                @if (isOffset(filter.property)) {
                  <nts-enum-text-box (keyDown)="onDown($event, filter.property)"
                    [propertyViewModel]="filter.property">
                  </nts-enum-text-box>
                }
                @if (isExternal(filter.property)) {
                  <nts-ext-new-autocomplete-text-box
                    [appendTo]="'body'"
                    (keyDown)="onDown($event, filter.property)"
                    [externalPropertyViewModel]="filter.property"
                    [decodeProperties]="filter.property.decodeProperties"
                    [searchProperties]="filter.property.searchProperties"
                    [fieldSeparator]="filter.property.fieldSeparator"
                    [showCodeInDescription]="filter.property.showCode"
                    [updateOnBlur]="true">
                  </nts-ext-new-autocomplete-text-box>
                }
              </div>
            }
          </div>
        </div>
      </div>
    }

    <div class="grid-container">
      <nts-loader [isVisible]="masterViewModel.actionInProgress$ | async">
      </nts-loader>
      <nts-grid class="full-column" (rowDoubleClick)="selectRow()" (keydown.enter)="selectRow()"
        (onGridOptionsReady)="onGridOptionsReady($event)" [showErrorsInCells]="false"
        [collectionViewModel]="masterViewModel.searchResult" [autoCreateRow]="false"
        [minRowNumberHeight]="0" [pagination]="true" [defaultCommandsName]="[]"
        [columns]="masterViewModel.searchResultColumns"
        (onColumnsChanged)="masterViewModel.onSearchColumnsChanged($event)"
        [customViewCommandsName]="['toggleExtendedFilterCommand']">
      </nts-grid>
    </div>

  </div>
</div>
